/**
* DevExpress Analytics (property-grid\internal\_popupService.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var PopupService = (function () {
    function PopupService() {
        this.data = ko.observable();
        this.title = ko.observable();
        this.visible = ko.observable(false);
        this.disabled = ko.observable(false);
        this.actions = ko.observableArray([]);
        this.target = ko.observable();
    }
    return PopupService;
}());
exports.PopupService = PopupService;
